import React from 'react';
import { motion } from 'framer-motion';
import { Icon } from '../ui/Icon';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section id="comprar" className="py-20 bg-gradient-to-br from-black via-gray-900 to-black text-white relative overflow-hidden" data-id="element-49">
      {/* Background decoration */}
      <div className="absolute inset-0" data-id="element-50">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl" data-id="element-51" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl" data-id="element-52" />
      </div>

      <div className="relative max-w-4xl mx-auto px-6 text-center" data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-54">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-orange-600 text-black px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider mb-6" data-id="element-55">
            <Icon name="fire" size={18} data-id="element-56" />
            Última Oportunidad
          </div>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold mb-8 leading-tight" data-id="element-57">
            ¿Listo para entrar a las grabaciones del Bootcamp completo?
          </h2>

          {/* Countdown Timer */}
          <div className="mb-8" data-id="element-58">
            <CountdownTimer data-id="element-59" />
          </div>

          <p className="text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-60">
            Si alguna vez quisiste aprender InfoCommerce + IA directamente de
            mí… sin pagar $997 o más… esta es tu oportunidad más barata del año.
          </p>

          <div className="bg-gray-900 border-2 border-orange-500/30 rounded-2xl p-8 mb-8" data-id="element-61">
            <div className="text-sm text-gray-400 uppercase tracking-wider mb-2" data-id="element-62">
              Promo de Navidad
            </div>
            <div className="text-5xl md:text-6xl font-extrabold text-orange-400 mb-4" data-id="element-63">
              $497 USD
            </div>
            <div className="text-gray-300 mb-6" data-id="element-64">
              Acceso inmediato a las 5 sesiones + prompts + GPTs
            </div>

            <a href="https://www.fanbasis.com/agency-checkout/true-marketer/xGRln" className="group relative inline-flex items-center justify-center px-12 py-5 text-xl font-bold text-white transition-all duration-300 bg-gradient-to-r from-[#FF6B35] to-[#F7931E] rounded-full hover:shadow-2xl hover:shadow-orange-500/50 hover:scale-105 animate-pulse-slow" data-id="element-65">
              ASEGURA TU ACCESO AHORA
            </a>
          </div>

          <div className="flex items-center justify-center gap-2 text-red-400 font-medium" data-id="element-66">
            <Icon name="clock" size={20} data-id="element-67" />
            <span data-id="element-68">
              Da clic aquí para asegurar tu acceso antes de que cierre.
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}